












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Form, FormItem, Input } from 'element-ui';

// For error messages
import { i18n } from '@/plugins/i18n';

@Component({
  components: {
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class SaveTemplate extends Vue {
  @Prop({ default: false }) public open!: boolean;
  private timeoutRef = null;
  private templateInput = {
    inputName: ''
  };

  private readonly rules = {
    inputName: [
      {
        validator: this.validateTemplate,
        trigger: ['change']
      }
    ]
  };

  $refs!: {
    templateForm: HTMLFormElement;
  };

  /**
   * Custom validation checking if template name is not empty and not already taken
   * API is from Element UI
   */
  private validateTemplate(rule, value, callback) {
    const templates = this.$store.state.BillItem.quoteTemplates;
    if (value === '') {
      callback(new Error(i18n.t('validation.required').toString()));
    }
    // We don't wanna validate previous inputs
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
    // Timeout so the validation is not "agressive" for the user
    this.timeoutRef = setTimeout(() => {
      if (templates.some((qt: any) => value === qt.name)) {
        callback(new Error(i18n.t('inquiry.quote.template.save-error').toString()));
      } else {
        callback();
      }
    }, 1000);
  };

  private closeModal() {
    this.$refs.templateForm.resetFields();
    this.$emit('close');
  }

  private submit(): void {
    this.$refs.templateForm.validate((valid: boolean) => {
      if (!valid) {
        return;
      }

      this.$store.dispatch('BillItem/createTemplate', {
        shipmentId: this.$route.params.id,
        name: this.templateInput.inputName
      });
      this.closeModal();
    });
  }
}
